import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-convert",
  "use": "icon-convert-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-convert\"><defs><style type=\"text/css\"></style></defs><path d=\"M46.435109 394.463614H977.976716a43.350032 43.350032 0 0 0 43.350032-43.350032l-0.007225-0.093925a43.306682 43.306682 0 0 0-18.445438-36.298426L654.90338 70.508827a43.350032 43.350032 0 0 0-49.794737 70.964002l236.936824 166.290721H46.435109a43.350032 43.350032 0 0 0 0 86.700064zM977.976716 600.022239H46.435109a43.350032 43.350032 0 0 0-43.350032 43.350032l0.007225 0.07225a43.306682 43.306682 0 0 0 18.445439 36.312877l347.985155 244.212404a43.313907 43.313907 0 0 0 60.386594-10.584633 43.342807 43.342807 0 0 0-10.577408-60.379369L182.380809 686.722303H977.976716a43.350032 43.350032 0 0 0 0-86.700064z\" fill=\"#231815\" p-id=\"2527\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/convert.svg
// module id = +qJY
// module chunks = 81